module.exports = __webpack_public_path__ + "static/media/RecomendaFortaleza.0086a8b3.jpg";